// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__3Xxg6","cardContainer":"Projects_cardContainer__TI+lU","heading":"Projects_heading__ic9Op"};